/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav P�ibyl (pribyl@cadwork.cz)
 *
 */

import IScene from "../scene_interface";
import Aggregation from "./aggregation";
import IDocument from "./document_interface";

export default
class ModelsAggregation extends Aggregation {
    constructor(aSceneAPI: IScene, aSceneDocument: IDocument) {
        super(aSceneAPI, aSceneDocument);
    }

    public removeWithContent() {
        for (let key in this._objects) {
            let object = this._objects[key];
            this._sceneDocument.removeModel(object);
        }
    }
}
